export const DOUBLELIFT_BANNER = {
  title: "Doublelift teaches: advanced ad carry".toUpperCase(),
  descriptionHtml:
    "Lifetime access to DoubleLift's secret tips and tricks. Learn how to become a veteran pro ADC player from the most seasoned ADC in all of North America.",
  btnCopy: "BUY NOW",
  btnFn: () => {
    window.location.href = "/al-doublelift-course"
  },
  image: require("@/assets/images/ad-banner/doublelift-course/doublelift.png"),
  backgroundImage: require("@/assets/images/ad-banner/doublelift-course/bg.png"),
  backgroundImageSm: require("@/assets/images/ad-banner/doublelift-course/bg-sm.png"),
  imageSm: require("@/assets/images/ad-banner/doublelift-course/doublelift.png"),
  actionHelper: "$20<span class='crossed'>$96</span>",
}



// WEBPACK FOOTER //
// ./src/store/modules/ad-banner/ad-banner.constants.js